import React,{useState,useRef} from 'react'
import { Modal, Button,Slider } from 'antd';
import AvatarEditor from "react-avatar-editor";


function Crop_modal(props) {
    const [slideValue, setSlideValue] = useState(10);
    const cropRef = useRef(null);
    const [data] = useState(props.fileAttributes[props.fileAttributesCurrentSelected][0])

    const handleSave = async () => {
      if (cropRef) {
        const dataUrl = cropRef.current.getImage().toDataURL();
        const blob = await (await fetch(dataUrl)).blob();
        let file = new File([blob], data.name, { type: blob.type });
        file = Object.assign(file,{preview:URL.createObjectURL(file)})
        props.fileAttributes_upload(props.fileAttributesCurrentSelected,[file])
      }
    }


  return (
    <Modal
    className='cropimg'
    title="Crop or Resize Image"
    visible={props.cropModalOpen}
    onCancel={()=>props.closeCropModalOpen()}
    onOk={handleSave}
    style={{display:'flex',justifyContent:'center',top:'4%'}}
    maskClosable={false}
  >

<AvatarEditor
          ref={cropRef}
          image={props.fileAttributes[props.fileAttributesCurrentSelected][0].preview}
          style={{ width: "100%", height: "100%" }}
          border={50}
          borderRadius={150}
          color={[0, 0, 0, 0.72]}
          scale={slideValue / 10}
          rotate={0}
        />
         <Slider
          defaultValue={slideValue}
          max={50}
          value={slideValue}
          onChange={(e) => setSlideValue(e)}
        />


  </Modal>
  )
}

export default Crop_modal


// WEBPACK FOOTER //
// ./src/scenes/Profile/crop_modal.js